import { useEffect, useState } from 'react'
import { PaginationState } from '@tanstack/react-table'
import dayjs, { Dayjs } from 'dayjs'

export function useTimeTrackingFilters() {
  const [from, setFrom] = useState<Dayjs>(dayjs().startOf('month'))
  const [to, setTo] = useState<Dayjs>(dayjs().endOf('month'))
  const [selectedStaffId, setSelectedStaffId] = useState<string | null>(null)
  const [pagination, setPagination] = useState<PaginationState>({ pageIndex: 0, pageSize: 5 })

  useEffect(() => {
    setPagination((prev) => (prev.pageIndex === 0 ? prev : { ...prev, pageIndex: 0 }))
  }, [from, to, selectedStaffId])

  return {
    from,
    to,
    selectedStaffId,
    pagination,
    setFrom,
    setTo,
    setSelectedStaffId,
    setPagination,
  }
}
